import { createContext } from 'react';

/**
 * Create contexts to be used across components
 */

const MatchContext = createContext(null);
const ConnectionContext = createContext(null);


export { MatchContext, ConnectionContext };

